/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Adr_Preview_Aria_LabelInputs */

const en_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR preview`)
};

const fr_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu ADR`)
};

const de_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR-Vorschau`)
};

const it_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima ADR`)
};

const ru_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр ADR`)
};

const es_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de ADR`)
};

const zh_cn2_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADR预览`)
};

const ja_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADRプレビュー`)
};

const hi_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एडीआर पूर्वावलोकन`)
};

const pt_pt2_player_adr_preview_aria_label = /** @type {(inputs: Player_Adr_Preview_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prévia de ADR`)
};

/**
* | output |
* | --- |
* | "ADR preview" |
*
* @param {Player_Adr_Preview_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_adr_preview_aria_label = /** @type {((inputs?: Player_Adr_Preview_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Adr_Preview_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_adr_preview_aria_label(inputs)
	if (locale === "de") return de_player_adr_preview_aria_label(inputs)
	if (locale === "it") return it_player_adr_preview_aria_label(inputs)
	if (locale === "ru") return ru_player_adr_preview_aria_label(inputs)
	if (locale === "es") return es_player_adr_preview_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_adr_preview_aria_label(inputs)
	if (locale === "ja") return ja_player_adr_preview_aria_label(inputs)
	if (locale === "hi") return hi_player_adr_preview_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_adr_preview_aria_label(inputs)
	return en_player_adr_preview_aria_label(inputs)
});